(() => {
  const selector = '.trade-signup__form shopify-forms-embed';
  const observedForms = new WeakSet();
  const waitingForms = new WeakSet();
  const addSuccessMark = (form) => {
    const shadow = form.shadowRoot;
    if (!shadow || shadow.querySelector('[data-trade-success-mark]')) return;

    const copy = shadow.textContent || '';
    if (!/application received|pricing becomes available once approved/i.test(copy)) return;

    const style = document.createElement('style');
    style.textContent = `
      :host { position: relative; }
      [data-trade-success-mark] {
        position: absolute;
        top: 24px;
        right: 24px;
        display: grid;
        place-items: center;
        width: 48px;
        height: 48px;
        border: 1px solid #b9ddc0;
        border-radius: 50%;
        color: #276a36;
        background: #eff8f0;
      }
      @media (max-width: 700px) {
        [data-trade-success-mark] { top: 20px; right: 20px; width: 42px; height: 42px; }
      }
    `;
    const mark = document.createElement('span');
    mark.setAttribute('data-trade-success-mark', '');
    mark.setAttribute('aria-hidden', 'true');
    mark.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4.2 4.2L19 6.5"/></svg>';
    shadow.append(style, mark);
  };

  const observeForm = (form, attempt = 0) => {
    if (observedForms.has(form) || !form.isConnected) return;
    if (!form.shadowRoot) {
      if (waitingForms.has(form)) return;
      // The embed can enter the page before its custom element is ready.
      if (attempt < 40) {
        waitingForms.add(form);
        window.setTimeout(() => {
          waitingForms.delete(form);
          observeForm(form, attempt + 1);
        }, 250);
      }
      return;
    }
    observedForms.add(form);
    const update = () => addSuccessMark(form);
    const observer = new MutationObserver(update);
    observer.observe(form.shadowRoot, { childList: true, subtree: true, characterData: true });
    update();
  };

  const discoverForms = () => {
    document.querySelectorAll(selector).forEach((form) => observeForm(form));
  };

  discoverForms();
  document.querySelectorAll('.trade-signup__form').forEach((formRoot) => {
    const observer = new MutationObserver(discoverForms);
    observer.observe(formRoot, { childList: true, subtree: true });
  });
  window.customElements.whenDefined('shopify-forms-embed').then(discoverForms);
})();
